// src/components/TemplateSelector.js
import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../firebase';

const TemplateSelector = ({ onSelect }) => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');

  useEffect(() => {
    const fetchTemplates = async () => {
      const user = auth.currentUser;

      if (user) {
        const q = query(collection(db, 'templates'), where('userId', '==', user.uid));
        const querySnapshot = await getDocs(q);
        setTemplates(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      }
    };

    fetchTemplates();
  }, []);

  const handleChange = (event) => {
    const template = templates.find(t => t.id === event.target.value);
    setSelectedTemplate(event.target.value);
    onSelect(template);
  };

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel>Template</InputLabel>
      <Select
        value={selectedTemplate}
        onChange={handleChange}
        label="Template"
      >
        {templates.map((template) => (
          <MenuItem key={template.id} value={template.id}>
            {template.templateName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TemplateSelector;
